'use client';

import {styled} from '@mui/material/styles';
import NextLink from 'next/link';
import {LINK_FONT_SIZE, linkShouldForwardProp, type LinkBaseProps} from './link-base';
import {Typography} from './Typography';

export type LinkProps = LinkBaseProps;

const Root = styled(NextLink, {shouldForwardProp: linkShouldForwardProp})(({theme}) => ({
  color: theme.palette.colors.text.primary.default,
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  '&:hover': {color: theme.palette.colors.text.primary.hover},
  '&:visited': {color: theme.palette.colors.text.primary.active},
}));

export function Link({size = 'lg', children, ...rest}: LinkProps) {
  return (
    <Root {...rest}>
      <Typography as="span" family="primary" size={LINK_FONT_SIZE[size]} weight="medium" sx={{color: 'inherit', letterSpacing: 0}}>
        {children}
      </Typography>
    </Root>
  );
}

Link.displayName = 'Link';
